import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PopupComponent } from 'src/app/shared/components/popup/popup.component';

export function canDeactivate(
  hasUnsavedChanges: () => boolean,
  modalService: NgbModal,
): boolean | Promise<boolean> {
  if (hasUnsavedChanges()) {
    const message = {
      contentTitle: 'Unsaved Changes',
      messages: 'Your changes will be lost. Do you want to proceed?',
    };

    return new Promise((resolve) => {
      const modalRef = modalService.open(PopupComponent);
      modalRef.componentInstance.contentTitle = message.contentTitle;
      modalRef.componentInstance.messages = [message.messages];
      modalRef.componentInstance.openModal('CONFIRMATION');

      modalRef.result
        .then((result: string) => {
          if (result === 'YES') {
            resolve(true); // Allow navigation
          } else {
            resolve(false); // Prevent navigation
          }
        })
        .catch(() => resolve(false));
    });
  }

  return true;
}
